import {VkAccountType} from './accounts-type';

export function getVkAccountInfo(vkAccount: VkAccountType): string {
    if (vkAccount.lastName && vkAccount.firstName) {
        return `${vkAccount.lastName} ${vkAccount.firstName}`;
    }

    return vkAccount.email || vkAccount.accountId || String(vkAccount.id);
}
